<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="showDetails">
        <v-row>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Type</v-card-title>
              <v-card-text>{{ summary.type }}</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Cost</v-card-title>
              <v-card-text>{{ summary.cost }}</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Total Contacts</v-card-title>
              <v-card-text>{{ summary.totalContacts }}</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Valid Contacts</v-card-title>
              <v-card-text>{{ summary.contacts }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-toolbar flat dark color="success">
            <v-spacer/>
            <v-toolbar-title> Check System Cost</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-card-text v-if="!loading">
            <v-form class="mt-3" >
              <v-autocomplete dense small-chips chips deletable-chips outlined label="Service to Check"
                              v-model="smsCampaignForm.type"
                              :items="services" item-text="name" item-value="value"/>
              <v-autocomplete dense small-chips chips deletable-chips outlined label="Level to Check"
                              v-model="smsCampaignForm.level"
                              :items="levels" item-text="name" item-value="value"/>
              <v-autocomplete return-object v-if="smsCampaignForm.level" dense chips deletable-chips outlined
                              label="County"
                              :items="counties" item-text="county" item-value="county" @change="getConstituency"/>
              <v-autocomplete v-if="checkLevel('constituency')" dense chips deletable-chips outlined
                              label="Constituency"
                              :items="constituencies" item-text="constituency" item-value="value" return-object
                              @change="getWard"/>
              <v-autocomplete v-if="checkLevel('ward')" dense chips deletable-chips return-object outlined label="Ward"
                              :items="wards" item-text="ward" item-value="value" @change="getPollingStation"/>
              <v-autocomplete v-if="checkLevel('polling')" dense chips deletable-chips outlined label="Polling Station"
                              v-model="smsCampaignForm.pollingstation"
                              :items="pollingstations" item-text="pollingstation" item-value="value"/>
              <v-textarea outlined v-model="smsCampaignForm.message" label="Enter Message To Send"></v-textarea>

            </v-form>
            <v-card-actions>
              <v-spacer/>
              <v-btn @click="RegisterClientAdmin()" color="green" dark>
                Check Price
              </v-btn>
            </v-card-actions>
          </v-card-text>
          <v-progress-circular indeterminate color="red" v-if="loading"/>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {getRequest, postRequest} from "@/api/apirepository";

export default {
  name: "CostChecker",
  data() {
    return {
      loading: false,
      showDetails: false,
      summary: [],
      wards: [],
      counties: [],
      constituencies: [],
      pollingstations: [],
      levels: [
        {name: 'County', value: 'county'},
        {name: 'Constituency', value: 'constituency'},
        {name: 'Ward', value: 'ward'},
        {name: 'Polling Station', value: 'pollingstation'},
      ],
      services: [
        {name: 'SMS Only', value: 'sms'},
        {name: 'USSD Poll', value: 'ussd'},
        {name: 'Call Poll', value: 'call'},
      ],
      smsCampaignForm: new Form({
        id: "",
        county: "",
        constituency: "",
        ward: "",
        pollingstation: "",
        level: "",
        type: "",
        message: "",
      }),
    }
  },
  methods: {
    getCounties() {
      postRequest('counties').then(({data}) => {
        this.counties = data;
      }).catch(e => {
        console.log(e)
      })
    },
    checkLevel(e) {
      if (e === 'constituency') {
        if (this.smsCampaignForm.level === 'county') {
          return false;
        } else if (this.smsCampaignForm.level === 'constituency' || this.smsCampaignForm.level === 'ward' || this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      } else if (e === 'ward') {
        if (this.smsCampaignForm.level === 'county' || this.smsCampaignForm.level === 'constituency') {
          return false;
        } else if (this.smsCampaignForm.level === 'ward' || this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      } else if (e === 'polling') {
        if (this.smsCampaignForm.level === 'county' || this.smsCampaignForm.level === 'constituency' || this.smsCampaignForm.level === 'ward') {
          return false;
        } else if (this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      }
    },
    getConstituency(e) {
      this.smsCampaignForm.county = e.county;
      if (this.checkLevel('constituency')) {
        postRequest('constituencies', {
          county: e.county
        }).then(({data}) => {
          this.constituencies = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getWard(e) {
      this.smsCampaignForm.constituency = e.constituency;
      if (this.checkLevel('ward')) {
        postRequest('wards', {
              constituency: e.constituency,
              county: e.county,
            }
        ).then(({data}) => {
          this.wards = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getPollingStation(e) {
      this.smsCampaignForm.ward = e.ward;
      if (this.checkLevel('polling')) {
        postRequest('pollingstations', {

          ward: e.ward

        }).then(({data}) => {
          this.pollingstations = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    RegisterClientAdmin() {
      this.loading = true;
      postRequest('checkSystemCost', this.smsCampaignForm).then(({data}) => {
        this.showDetails = true;
        this.summary = data;
        this.loading = false;
        this.smsCampaignForm.reset()
      }).catch(e => {
        swal.fire('error', 'Something went wrong', 'error')
        this.loading = false;
      })
    }
  },
  created() {
    this.getCounties()
  }
}
</script>

<style scoped>

</style>